import { render, staticRenderFns } from "./supervisionandServices.vue?vue&type=template&id=2000eedf&scoped=true&"
import script from "./supervisionandServices.vue?vue&type=script&lang=js&"
export * from "./supervisionandServices.vue?vue&type=script&lang=js&"
import style0 from "./supervisionandServices.vue?vue&type=style&index=0&id=2000eedf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2000eedf",
  null
  
)

export default component.exports